define('shared/util/promise/break',['./Result'], function (Result) {
    return function(result) {
        throw new Result(result);
    };
});
